import { Reveal } from "./Reveal";
import { Star } from "lucide-react";

const items = [
  {
    quote:
      "My shoulder was in pain almost every day for 2 years and nothing helped. JC gave me a list of simple mobility and flexibility exercises — within a week the pain was gone. Great guy offering great help.",
    name: "Jazz",
    role: "Shoulder & mobility",
  },
  {
    quote:
      "I started 1½ years ago at 175lbs and could feel the weight in my knees. JC built me a weekly program and kept me encouraged — even through COVID. Today I'm at my ideal 166lbs and feel healthier than I have in years. Thank you JC, you're AWESOME!",
    name: "Peter",
    role: "Weight-loss journey",
  },
  {
    quote:
      "When I started I couldn't do five pushups in a row. JC listened to my goals without judgement and built a plan at the right pace for my body. It's never too late, and you're never too old, to change your life.",
    name: "Rosemary",
    role: "Return from injury",
  },
  {
    quote: "Down 18kg and stronger than I've ever been. Jean Claude changed how I see training entirely.",
    name: "Marcus T.",
    role: "1-on-1 Client",
  },
  {
    quote: "The bootcamps are addictive. The energy, the people, the results — I actually look forward to 6am now.",
    name: "Priya S.",
    role: "Bootcamp Member",
  },
  {
    quote: "Hit a 180kg deadlift after his S&C block. Programming is next level and the coaching is personal.",
    name: "Deon R.",
    role: "S&C Athlete",
  },
];

export default function Testimonials() {
  return (
    <section className="bg-[#050505] py-24 md:py-32 border-t border-[#222]" data-testid="testimonials">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <Reveal>
          <p className="font-mono-accent text-[#005EEA] text-xs mb-12">Proof</p>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {items.map((t, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="h-full border border-[#222] bg-[#0b0b0b] p-8 flex flex-col justify-between hover:border-[#005EEA]/40 transition-colors">
                <div>
                  <div className="flex gap-1 mb-6">
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} size={14} className="fill-[#005EEA] text-[#005EEA]" />
                    ))}
                  </div>
                  <p className="text-white text-lg md:text-xl leading-relaxed">"{t.quote}"</p>
                </div>
                <div className="mt-8 pt-6 border-t border-[#222]">
                  <p className="font-display text-white text-lg leading-none">{t.name}</p>
                  <p className="font-mono-accent text-[10px] text-[#666] mt-2">{t.role}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
